import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import "firebase/firestore";
// import router from "@/routes";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    userProfile: null,
    userNames: null,
  },
  mutations: {
    updateUser(state, { user }) {
      Vue.set(state, "user", user);
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setProfile(state, payload) {
      Vue.set(state, "userProfile", payload);
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setUserNames(state, payload) {
      state.userNames = payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    userProfile(state) {
      return state.userProfile;
    },
  },
  computed: {},
  actions: {
    signUserUp({ commit }, payload) {
      var id = "";
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((user) => {
          const newUser = {
            id: user.user.uid,
          };
          id = user.user.uid;
          commit("setUser", newUser);
          // router.push("/profile/" + user.user.uid);
        })
        .then(() => {
          const dateNow = new Date();
          var hours = dateNow.getHours();
          if (hours > 12) {
            hours -= 12;
          }
          var datestring =
            ("0" + (dateNow.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + dateNow.getDate()).slice(-2) +
            "/" +
            dateNow.getFullYear() +
            " " +
            ("0" + hours).slice(-2) +
            ":" +
            ("0" + dateNow.getMinutes()).slice(-2);
          if (dateNow.getHours() <= 12) {
            datestring += "am";
          } else {
            datestring += "pm";
          }

          var interact = {
            Congress: 0,
            Environment: 0,
            Education: 0,
            "Supreme Court": 0,
            "Public Health": 0,
            "Public Safety": 0,
            Military: 0,
            Economy: 0,
            "International Affairs": 0,
            "Social Justice": 0,
            "Federal Spending": 0,
            Technology: 0,
            Entertainment: 0,
            "Human Rights": 0,
            Litigation: 0,
            Politics: 0,
            "United States": 0,
            Alabama: 0,
            Alaska: 0,
            "American Samoa": 0,
            Arizona: 0,
            Arkansas: 0,
            California: 0,
            Colorado: 0,
            Connecticut: 0,
            Delaware: 0,
            "Washington D.C.": 0,
            Florida: 0,
            Georgia: 0,
            Guam: 0,
            Hawaii: 0,
            Idaho: 0,
            Illinois: 0,
            Indiana: 0,
            International: 0,
            Iowa: 0,
            Kansas: 0,
            Kentucky: 0,
            Louisiana: 0,
            Maine: 0,
            Maryland: 0,
            Massachusetts: 0,
            Michigan: 0,
            Minnesota: 0,
            Mississippi: 0,
            Missouri: 0,
            Montana: 0,
            Nebraska: 0,
            Nevada: 0,
            "New Hampshire": 0,
            "New Jersey": 0,
            "New Mexico": 0,
            "New York": 0,
            "North Carolina": 0,
            "North Dakota": 0,
            "Northern Mariana Islands": 0,
            Ohio: 0,
            Oklahoma: 0,
            Oregon: 0,
            Pennsylvania: 0,
            "Puerto Rico": 0,
            "Rhode Island": 0,
            "South Carolina": 0,
            "South Dakota": 0,
            Tennessee: 0,
            Texas: 0,
            "U.S. Virgin Islands": 0,
            Utah: 0,
            Vermont: 0,
            Virginia: 0,
            Washington: 0,
            "West Virginia": 0,
            Wisconsin: 0,
            Wyoming: 0,
          };

          firebase
            .firestore()
            .collection("users")
            .doc(id)
            .set({
              email: payload.email,
              follow_tags: [],
              id: id,
              uid: id,
              supporter_count: 0,
              comment_count: 0,
              promoted_count: 0,
              supporter_ids: [],
              promoted_accounts: [],
              forum_posts: [],
              forum_commentposts: [],
              impact_role: "Novice",
              impact_score: 0,
              clearance_level: 0,
              joined: datestring,
              isAdmin: false,
              profile: false,
              interacts: interact,
              newsletter: true,
            });
        })
        .then(() => {
          firebase
            .firestore()
            .collection("users")
            .doc(id)
            .get()
            .then((doc) => {
              if (doc.exists) {
                commit("setProfile", doc.data());
              } else {
                commit("setLoading", false);
                commit("setError", "No data found");
              }
            })
            .catch((error) => {
              commit("setLoading", false);
              commit("setError", error);
            });
        });
    },
    signUserOut({ commit }) {
      commit("setProfile", null);
    },
    fetchUserData({ commit }) {
      commit("setLoading", true);

      var db = firebase.firestore();
      var auth = firebase.auth();
      if (auth.currentUser) {
        db.collection("users")
          .doc(auth.currentUser.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              commit("setProfile", doc.data());
            } else {
              commit("setLoading", false);
              commit("setError", "No data found");
            }
          })
          .catch((error) => {
            commit("setLoading", false);
            commit("setError", error);
          });
      }
    },
    updateUserPic({ commit }, { image }) {
      var db = firebase.firestore();
      var auth = firebase.auth();
      let path = "profile_photos/" + auth.currentUser.uid;
      var storageref = firebase.storage().ref(path);
      storageref.put(image).then(() => {
        storageref.getDownloadURL().then(function(url) {
          db.collection("users")
            .doc(auth.currentUser.uid)
            .set(
              {
                photoURL: url,
              },
              { merge: true }
            )
            .then(() => commit("fetchUserData"));
        });
      });
    },
    updateUserData({ commit }, payload) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      var obj = JSON.parse(
        JSON.stringify(payload, function(k, v) {
          if (!v) {
            return null;
          }
          return v;
        })
      );
      db.collection("users")
        .doc(auth.currentUser.uid)
        .set(
          {
            uid: auth.currentUser.uid,
            name: obj.firstname + " " + obj.lastname,
            phone: obj.phone,
            email: obj.email,
            birthdate: obj.birthdate,
            gender: obj.gender,
            username: obj.username,
            updated: obj.updated,
            zipcode: obj.zipcode,
            bio: obj.bio,
            emailSwitch: obj.emailSwitch,
            stateSwitch: obj.stateSwitch,
            profile: true,
            tags: obj.tags,
            state: obj.state,
            newsletter: obj.newsletter,
          },
          { merge: true }
        )
        .then(() => commit("fetchUserData"));
    },
    addInteract({ commit }, { tags, value }) {
      commit("setLoading", true);

      var db = firebase.firestore();
      var auth = firebase.auth();
      db.collection("users")
        .doc(auth.currentUser.uid)
        .get()
        .then(function(userDoc) {
          var likes = userDoc.get("interacts");
          tags.forEach(function(val) {
            likes[val] = likes[val] + Math.round(value / tags.length);
          });
          db.collection("users")
            .doc(auth.currentUser.uid)
            .update({ interacts: likes });
        });
      commit("setLoading", false);
    },
    addStoryUpvote({ commit }, { forum }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      var self = this;
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("userUpvotes");
            var c = doc.get("count");

            var tags = doc.get("tags");
            c++;
            arr.push(auth.currentUser.uid);
            db.collection("concordposts")
              .doc(forum)
              .update({ userUpvotes: arr, count: c });
            db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var likes = userDoc.get("interacts");
                var stars = userDoc.get("forum_posts");
                if (!stars) 
                  stars = []
                var personaltag = userDoc.get("tags");
                personaltag.push(userDoc.get("state"));
                stars.push(forum);
                self.state.userProfile.forum_posts = stars;
                tags.forEach(function(val) {
                  likes[val] = likes[val] + Math.round(10000 / tags.length);
                });
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ interacts: likes, forum_posts: stars });
              });
          }
        })
        .then(() => commit("setLoading", false));
    },
    removeStoryUpvote({ commit }, { forum }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      var self = this;
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("userUpvotes");
            var c = doc.get("count");
            const index = arr.indexOf(auth.currentUser.uid);
            if (index > -1) {
              arr.splice(index, 1);
            }
            c--;
            db.collection("concordposts")
              .doc(forum)
              .update({ userUpvotes: arr, count: c });
          }
          db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var stars = userDoc.get("forum_posts");
                const index = stars.indexOf(forum);
                if (index > -1) {
                  stars.splice(index, 1);
                }

                self.state.userProfile.forum_posts = stars;
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ forum_posts: stars });
              });
        })
        .then(() => commit("setLoading", false));
    },
    addComment({ commit }, { forum, payload }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      var points = 225000;
      var self = this;
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            var tags = doc.get("tags");
            if (arr) {
              arr.push(payload);
              db.collection("concordposts")
                .doc(forum)
                .set({ sortedMessages: arr }, { merge: true });
            } else {
              var arr2 = [];
              points = 250000;
              arr2.push(payload);
              db.collection("concordposts")
                .doc(forum)
                .set({ sortedMessages: arr2 }, { merge: true });
            }

            db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var likes = userDoc.get("interacts");
                var personaltag = userDoc.get("tags");
                var forum_commentposts = userDoc.get("forum_commentposts")
                if (forum_commentposts && forum_commentposts.filter(e => e.id === forum).length == 0) {
                  forum_commentposts.push({comment: payload.message, id: forum})
                } else if (!forum_commentposts) {
                  forum_commentposts = [{comment: payload.message, id: forum}]
                }
                personaltag.push(userDoc.get("state"));
                tags.forEach(function(val) {
                  likes[val] = likes[val] + Math.round(points / tags.length);
                });
                self.state.userProfile.forum_commentposts = forum_commentposts;
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ interacts: likes, forum_commentposts: forum_commentposts });
              });
              
          }
        })
        .then(() => commit("setLoading", false));
    },
    removeComment({ commit }, { forum, message_id }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      var self = this;
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            const index = arr.findIndex((object) => {
              return object.messageID == message_id;
            });
            if (
              index > -1 &&
              arr[index].thread &&
              arr[index].thread.length > 0 &&
              !arr[index].deleted
            ) {
              arr[index].message = "";
              arr[index].links = [];
              arr[index].sender = "Redacted";
              arr[index].senderID = "";
              arr[index].count = 0;
              arr[index].deleted = true;
            } else if (index > -1) {
              arr.splice(index, 1);
            }
            db.collection("concordposts")
              .doc(forum)
              .set({ sortedMessages: arr }, { merge: true });
            db.collection("users")
            .doc(auth.currentUser.uid)
            .get()
            .then(function(userDoc) {
              var forum_commentposts = userDoc.get("forum_commentposts");
              const index = forum_commentposts.map((val) => val.id).indexOf(forum);
              if (index > -1) {
                forum_commentposts.splice(index, 1);
              }
              if (arr.filter((val) => val.senderID == auth.currentUser.uid).length > 0) {
                forum_commentposts.push({comment: arr.filter((val) => val.senderID == auth.currentUser.uid)[0].message, id: forum})
              }

              self.state.userProfile.forum_commentposts = forum_commentposts;
              db.collection("users")
                .doc(auth.currentUser.uid)
                .update({ forum_commentposts: forum_commentposts });
            });
          }
        })
        .then(() => commit("setLoading", false));
    },
    addCommentUpvote({ commit }, { forum, payload }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            var tags = doc.get("tags");
            arr.forEach((mess) => {
              if (mess.messageID === payload) {
                mess.count += 1;
                mess.userUpvotes.push(auth.currentUser.uid);
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
            db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var likes = userDoc.get("interacts");
                var personaltag = userDoc.get("tags");
                personaltag.push(userDoc.get("state"));
                tags.forEach(function(val) {
                  likes[val] = likes[val] + Math.round(3000 / tags.length);
                });
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ interacts: likes });
              });
          }
        })
        .then(() => commit("setLoading", false));
    },
    removeCommentUpvote({ commit }, { forum, payload }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            arr.forEach((mess) => {
              if (mess.messageID === payload) {
                mess.count -= 1;
                const index = mess.userUpvotes.indexOf(auth.currentUser.uid);
                if (index > -1) {
                  mess.userUpvotes.splice(index, 1);
                }
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
          }
        })
        .then(() => commit("setLoading", false));
    },
    addThread({ commit }, { forum, message, payload }) {
      commit("setLoading", true);
      var auth = firebase.auth();
      var db = firebase.firestore();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var tags = doc.get("tags");
            var arr = doc.get("sortedMessages");
            arr.forEach((mess) => {
              if (mess.messageID === message) {
                mess.thread.push(payload);
                mess.threads = true;
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
            db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var likes = userDoc.get("interacts");
                var personaltag = userDoc.get("tags");
                personaltag.push(userDoc.get("state"));
                tags.forEach(function(val) {
                  likes[val] = likes[val] + Math.round(40000 / tags.length);
                });
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ interacts: likes });
              });
          }
        })
        .then(() => commit("setLoading", false));
    },
    removeThread({ commit }, { forum, message, thread }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            arr.forEach((mess) => {
              if (mess.messageID === message) {
                const index = mess.thread.findIndex((object) => {
                  return object.messageID == thread;
                });
                if (index > -1) {
                  mess.thread.splice(index, 1);
                }
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
          }
        })
        .then(() => commit("setLoading", false));
    },
    addThreadUpvote({ commit }, { forum, message, thread }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            var tags = doc.get("tags");
            arr.forEach((mess) => {
              if (mess.messageID === message) {
                var arr2 = mess.thread;
                arr2.forEach((threads) => {
                  if (threads.messageID === thread) {
                    threads.count += 1;
                    threads.userUpvotes.push(auth.currentUser.uid);
                  }
                });
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
            db.collection("users")
              .doc(auth.currentUser.uid)
              .get()
              .then(function(userDoc) {
                var likes = userDoc.get("interacts");
                var personaltag = userDoc.get("tags");
                personaltag.push(userDoc.get("state"));
                tags.forEach(function(val) {
                  likes[val] = likes[val] + Math.round(3000 / tags.length);
                });
                db.collection("users")
                  .doc(auth.currentUser.uid)
                  .update({ interacts: likes });
              });
          }
        })
        .then(() => commit("setLoading", false));
    },
    removeThreadUpvote({ commit }, { forum, message, thread }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      var auth = firebase.auth();
      db.collection("concordposts")
        .doc(forum)
        .get()
        .then(function(doc) {
          if (doc.data()) {
            var arr = doc.get("sortedMessages");
            arr.forEach((mess) => {
              if (mess.messageID === message) {
                var arr2 = mess.thread;
                arr2.forEach((threads) => {
                  if (threads.messageID === thread) {
                    threads.count -= 1;
                    const index = threads.userUpvotes.indexOf(
                      auth.currentUser.uid
                    );
                    if (index > -1) {
                      threads.userUpvotes.splice(index, 1);
                    }
                  }
                });
              }
            });
            db.collection("concordposts")
              .doc(forum)
              .update({ sortedMessages: arr });
          }
        })
        .then(() => commit("setLoading", false));
    },
    getUserNames({ commit }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      db.collection("usernames")
        .doc("usernames")
        .get()
        .then(function(doc) {
          var arr = doc.get("names");
          commit("setUserNames", arr);
        })
        .then(() => commit("setLoading", false));
    },
    updateUsername({ commit }, { username }) {
      commit("setLoading", true);
      var db = firebase.firestore();
      db.collection("usernames")
        .doc("usernames")
        .get()
        .then(function(doc) {
          var arr = doc.get("names");
          arr.push(username);
          db.collection("usernames")
            .doc("usernames")
            .update({ names: arr });
        })
        .then(() => commit("getUserNames"));
    },
    // uploadStory(
    //   { commit },
    //   { title, files, userID, tag, sources, name, oldforum }
    // ) {
    //   commit("setLoading", true);
    //   setTimeout(() => {
    //     var dateNow = new Date().getTime();
    //     firebase
    //       .firestore()
    //       .collection("forums")
    //       .add({
    //         title: title,
    //         items: [],
    //         itemPath: files,
    //         sortedMessages: [],
    //         tags: tag,
    //         count: 0,
    //         links: sources,
    //         userUpvotes: [],
    //         name: name,
    //         creatorID: userID,
    //         time: dateNow,
    //       })
    //       .then((docRef) => {
    //         firebase
    //           .firestore()
    //           .collection("forums")
    //           .doc(docRef.id)
    //           .update({
    //             forum_id: docRef.id,
    //           });
    //         //add to persons forum_posts
    //         firebase
    //           .firestore()
    //           .collection("users")
    //           .doc(userID)
    //           .get()
    //           .then(function(doc) {
    //             var posts = doc.get("forum_posts");
    //             posts.push(docRef.id);
    //             firebase
    //               .firestore()
    //               .collection("users")
    //               .doc(userID)
    //               .update({ forum_posts: posts });
    //           });
    //         const FieldValue = firebase.firestore.FieldValue;
    //         firebase
    //           .firestore()
    //           .collection("userforums")
    //           .doc(oldforum)
    //           .update({
    //             title: FieldValue.delete(),
    //             items: FieldValue.delete(),
    //             itemPath: FieldValue.delete(),
    //             sortedMessages: FieldValue.delete(),
    //             tags: FieldValue.delete(),
    //             links: FieldValue.delete(),
    //             count: FieldValue.delete(),
    //             userUpvotes: FieldValue.delete(),
    //             name: FieldValue.delete(),
    //             creatorID: FieldValue.delete(),
    //             time: FieldValue.delete(),
    //             forum_id: FieldValue.delete(),
    //           });
    //         firebase
    //           .firestore()
    //           .collection("userforums")
    //           .doc(oldforum)
    //           .delete();
    //       })
    //       .then(() => commit("setLoading", false));
    //   }, 2000);
    // },
    uploadConcordPosts({ commit }, { title, files, userID, tag, sources, QTC }) {
      commit("setLoading", true);
      var arr = [];
      const num = Math.random() * 1000;
      let path = "concord_forum_posts/" + title + num + "/";
      for (var i = 0; i < files.length; i++) {
        let path2 = path + i;
        var storageref = firebase.storage().ref(path2);
        storageref.put(files[i]);
      }
      setTimeout(() => {
        var dateNow = new Date().getTime();
        firebase
          .firestore()
          .collection("concordposts")
          .add({
            title: title,
            items: arr,
            itemPath: path,
            sortedMessages: [],
            tags: tag,
            links: sources,
            count: 0,
            userUpvotes: [],
            name: "The Concord Report",
            creatorID: userID,
            time: dateNow,
            QTC: QTC
          })
          .then((docRef) => {
            firebase
              .firestore()
              .collection("concordposts")
              .doc(docRef.id)
              .update({
                forum_id: docRef.id,
              });

            // firebase
            //   .firestore()
            //   .collection("users")
            //   .doc(userID)
            //   .get()
            //   .then(function(doc) {
            //     var posts = doc.get("forum_posts");
            //     posts.push(docRef.id);
            //     firebase
            //       .firestore()
            //       .collection("users")
            //       .doc(userID)
            //       .update({ forum_posts: posts });
            //   });
          })
          .then(() => commit("setLoading", false));
      }, 2000);
    },
    uploadSuggestion({ commit }, { title, userID,  sources, tag, location, comments }) {
      commit("setLoading", true);
      
      setTimeout(() => {
        firebase
          .firestore()
          .collection("suggestions")
          .add({
            title: title,
            tags: tag,
            location: location,
            links: sources,
            creatorID: userID,
            read: false,
            comments: comments,
            time: Date.now(),
            readTime: Date.now()
          })
          .then((docRef) => {
            firebase
              .firestore()
              .collection("suggestions")
              .doc(docRef.id)
              .update({
                suggestion_id: docRef.id,
              });
          })
          .then(() => commit("setLoading", false));
      }, 2000);
    },
    // declineStory({ commit }, { oldforum, message, chosenReason }) {
    //   firebase
    //     .firestore()
    //     .collection("userforums")
    //     .doc(oldforum)
    //     .update({
    //       draft: true,
    //       message: message,
    //       chosenReason: chosenReason,
    //     })
    //     .then(() => commit("setLoading", false));
    // },
    // reuploadUserStory({ commit }, { oldforum }) {
    //   firebase
    //     .firestore()
    //     .collection("userforums")
    //     .doc(oldforum)
    //     .update({
    //       draft: false,
    //       message: "",
    //     })
    //     .then(() => commit("setLoading", false));
    // },
    // uploadUserStory({ commit }, { title, files, userID, tag, sources }) {
    //   commit("setLoading", true);
    //   var arr = [];
    //   const num = Math.random() * 1000;
    //   let path = "user_forum_posts/" + title + num + "/";
    //   for (var i = 0; i < files.length; i++) {
    //     let path2 = path + i;
    //     var storageref = firebase.storage().ref(path2);
    //     storageref.put(files[i]);
    //   }
    //   setTimeout(() => {
    //     var dateNow = new Date().getTime();
    //     firebase
    //       .firestore()
    //       .collection("userforums")
    //       .add({
    //         title: title,
    //         items: arr,
    //         itemPath: path,
    //         sortedMessages: [],
    //         tags: tag,
    //         links: sources,
    //         count: 0,
    //         userUpvotes: [],
    //         name: this.state.userProfile.name,
    //         creatorID: userID,
    //         time: dateNow,
    //         draft: false,
    //         message: "",
    //       })
    //       .then((docRef) => {
    //         firebase
    //           .firestore()
    //           .collection("userforums")
    //           .doc(docRef.id)
    //           .update({
    //             forum_id: docRef.id,
    //           });
    //       })
    //       .then(() => commit("setLoading", false));
    //   }, 2000);
    // },
    addFollow({ commit }, { followID, name, userID, userName }) {
      commit("setLoading", true);
      var tags = [];
      firebase
        .firestore()
        .collection("users")
        .doc(followID)
        .get()
        .then(function(doc) {
          var followers = doc.get("supporter_ids");
          tags = doc.get("tags");
          followers.push({ id: userID, name: userName });
          firebase
            .firestore()
            .collection("users")
            .doc(followID)
            .update({ supporter_ids: followers });

          firebase
            .firestore()
            .collection("users")
            .doc(userID)
            .get()
            .then(function(doc) {
              var following = doc.get("promoted_accounts");
              following.push({ id: followID, name: name });
              var likes = doc.get("interacts");
              var personaltag = doc.get("tags");
              personaltag.push(doc.get("state"));
              tags.forEach(function(val) {
                likes[val] = likes[val] + 5000;
              });
              firebase
                .firestore()
                .collection("users")
                .doc(userID)
                .update({ promoted_accounts: following, interacts: likes });
            });
        })
        .then(() => commit("setLoading", false));
    },
    report(
      { commit },
      {
        forum_id,
        message_id,
        submessage_id,
        reasonstr,
        chosenReason,
        concordPost,
      }
    ) {
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("reports")
        .doc("reports")
        .get()
        .then(function(doc) {
          var reports2 = doc.get("reports");
          reports2.push({
            forumID: forum_id,
            messageID: message_id,
            submessageID: submessage_id,
            reason: reasonstr,
            chosenReason: chosenReason,
            concordPost: concordPost,
          });
          firebase
            .firestore()
            .collection("reports")
            .doc("reports")
            .update({ reports: reports2 });
        });
    },
    reportUser({ commit }, { user_id, reasonstr, chosenReason }) {
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("reports")
        .doc("reports")
        .get()
        .then(function(doc) {
          var reports2 = doc.get("reports");
          reports2.push({
            user_id: user_id,
            reason: reasonstr,
            chosenReason: chosenReason,
          });
          firebase
            .firestore()
            .collection("reports")
            .doc("reports")
            .update({ reports: reports2 });
        });
    },
    unfollow({ commit }, { unfollowID, userID }) {
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("users")
        .doc(unfollowID)
        .get()
        .then(function(doc) {
          var followers = doc.get("supporter_ids");
          var i = 0;
          while (i < followers.length) {
            if (followers[i].id === userID) {
              followers.splice(i, 1);
              break;
            } else {
              ++i;
            }
          }
          firebase
            .firestore()
            .collection("users")
            .doc(unfollowID)
            .update({ supporter_ids: followers });
        });
      firebase
        .firestore()
        .collection("users")
        .doc(userID)
        .get()
        .then(function(doc) {
          var following = doc.get("promoted_accounts");
          var i = 0;
          while (i < following.length) {
            if (following[i].id === unfollowID) {
              following.splice(i, 1);
              break;
            } else {
              ++i;
            }
          }
          firebase
            .firestore()
            .collection("users")
            .doc(userID)
            .update({ promoted_accounts: following });
        })
        .then(() => commit("setLoading", false));
    },
    // deleteStory({ commit }, { oldforum }) {
    //   firebase
    //     .firestore()
    //     .collection("forums")
    //     .doc(oldforum)
    //     .get()
    //     .then((doc3) => {
    //       if (doc3.data()) {
    //         commit("deleteUserStory", oldforum);
    //       } else {
    //         commit("deleteConcordStory", oldforum);
    //       }
    //     });
    // },
    // deleteUserStory({ commit }, { oldforum }) {
    //   var auth = firebase.auth();
    //   ///add to list to tell me to delete!

    //   firebase
    //     .firestore()
    //     .collection("forums")
    //     .doc(oldforum)
    //     .get()
    //     .then((doc3) => {
    //       var path = doc3.get("itemPath");

    //       firebase
    //         .firestore()
    //         .collection("deletePaths")
    //         .doc("items")
    //         .get()
    //         .then((val) => {
    //           var items = val.get("items");
    //           items.push(path);
    //           firebase
    //             .firestore()
    //             .collection("deletePaths")
    //             .doc("items")
    //             .update({ items: items });
    //         });
    //     });
    //   const FieldValue = firebase.firestore.FieldValue;

    //   firebase
    //     .firestore()
    //     .collection("users")
    //     .doc(auth.currentUser.uid)
    //     .get()
    //     .then((doc2) => {
    //       var posts = doc2.get("forum_posts");
    //       var i = 0;
    //       for (i = 0; i < posts.length; i++) {
    //         if (posts[i] == oldforum) {
    //           posts.splice(i, 1);
    //         }
    //       }

    //       firebase
    //         .firestore()
    //         .collection("users")
    //         .doc(auth.currentUser.uid)
    //         .update({ forum_posts: posts });
    //     });

    //   firebase
    //     .firestore()
    //     .collection("forums")
    //     .doc(oldforum)
    //     .update({
    //       title: FieldValue.delete(),
    //       items: FieldValue.delete(),
    //       itemPath: FieldValue.delete(),
    //       sortedMessages: FieldValue.delete(),
    //       tags: FieldValue.delete(),
    //       links: FieldValue.delete(),
    //       count: FieldValue.delete(),
    //       userUpvotes: FieldValue.delete(),
    //       name: FieldValue.delete(),
    //       creatorID: FieldValue.delete(),
    //       time: FieldValue.delete(),
    //       forum_id: FieldValue.delete(),
    //     });
    //   firebase
    //     .firestore()
    //     .collection("forums")
    //     .doc(oldforum)
    //     .delete()
    //     .then(() => commit("setLoading", false));
    // },
    //     deleteConcordStory({ commit }, { oldforum }) {
    //       var auth = firebase.auth();
    //       ///add to list to tell me to delete!

    //       firebase
    //         .firestore()
    //         .collection("concordposts")
    //         .doc(oldforum)
    //         .get()
    //         .then((doc3) => {
    //           var path = doc3.get("itemPath");
    //           firebase
    //             .firestore()
    //             .collection("deletePaths")
    //             .doc("items")
    //             .get()
    //             .then((val) => {
    //               var items = val.get("items");
    //               items.push(path);
    //               firebase
    //                 .firestore()
    //                 .collection("deletePaths")
    //                 .doc("items")
    //                 .update({ items: items });
    //             });
    //         });
    //       const FieldValue = firebase.firestore.FieldValue;

    //       firebase
    //         .firestore()
    //         .collection("users")
    //         .doc(auth.currentUser.uid)
    //         .get()
    //         .then((doc2) => {
    //           var posts = doc2.get("forum_posts");
    //           var i = 0;
    //           for (i = 0; i < posts.length; i++) {
    //             if (posts[i] == oldforum) {
    //               posts.splice(i, 1);
    //             }
    //           }

    //           firebase
    //             .firestore()
    //             .collection("users")
    //             .doc(auth.currentUser.uid)
    //             .update({ forum_posts: posts });
    //         });

    //       firebase
    //         .firestore()
    //         .collection("concordposts")
    //         .doc(oldforum)
    //         .update({
    //           title: FieldValue.delete(),
    //           items: FieldValue.delete(),
    //           itemPath: FieldValue.delete(),
    //           sortedMessages: FieldValue.delete(),
    //           tags: FieldValue.delete(),
    //           links: FieldValue.delete(),
    //           count: FieldValue.delete(),
    //           userUpvotes: FieldValue.delete(),
    //           name: FieldValue.delete(),
    //           creatorID: FieldValue.delete(),
    //           time: FieldValue.delete(),
    //           forum_id: FieldValue.delete(),
    //         });
    //       firebase
    //         .firestore()
    //         .collection("concordposts")
    //         .doc(oldforum)
    //         .delete()
    //         .then(() => commit("setLoading", false));
    //     },
  },
});
